'use client';
import NotFound from '@/app/not-found';
import { Website } from '@/types/website';
import React, { useEffect } from 'react';

interface IProps {
    children: React.ReactNode;
    website: Website | undefined;
}

const NotFoundLayout: React.FC<IProps> = ({ children, website }) => {
    if (website?.siteId === '' || website?.siteId === undefined) {
        console.error('website-null:',website);
        return <NotFound />;
    }

    return <>{children}</>;
};

export default NotFoundLayout;
